export default function RequireIcon() {
    return (
      <span className='text-red-600'>*</span>
    )
  }